var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('v-app',[_c('v-main',[_c('header-market-place3'),_vm._v(" "),_c('header-mobile'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('notify'),_vm._v(" "),_c('newsletters'),_vm._v(" "),_c('footer-default'),_vm._v(" "),_c('navigation-list'),_vm._v(" "),_c('mobile-drawer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }